import { Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { StepsStoreService } from '../core/services';


@Injectable({
  providedIn: 'root'
})
export class DocumentTypeGuard {
  constructor(private router: Router, private stepsStore: StepsStoreService) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.stepsStore.step.documentType) return true;

    this.router.navigate(['/select-document'], { queryParamsHandling: 'merge' });

    return false;
  }

}
